module.exports = __webpack_public_path__ + "img/93aa561.jpg";